import React from "react";
import "./About.scss";
import { motion } from "framer-motion";
import portfolio from "../../assets/nur.jpg";
import { bios } from "../../Data";

const About = () => {
  const buttonVariants = {
    hover: {
      scale: 1,
      textShadow: "0px 0px 8px rgb(255,255,255)",
      boxShadow: "0px 0px 8px rgb(255,255,255)",
      transition: {
        duration: 0.3,
        yoyo: 5,
      },
    },
  };
  return (
    <div className="container" id="about">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="title"
      >
        <span>Who Am I?</span>
        <h1>About Me</h1>
      </motion.div>

      <div className="about_container">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [-250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="about_left"
        >
          <motion.img
            // whileHover={{ y: -20, x: -20 }}
            // transition={{ duration: 0.3 }}
            src={portfolio}
            alt=""
          />
        </motion.div>
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="about_right"
        >
          <p>
            I am a Computer Science and Engineering graduate from Green University of Bangladesh, passionate about full-stack web development. Skilled in modern frontend and backend technologies, I focus on building scalable, user-friendly, and impactful digital solutions. With a balance of technical expertise and creative problem-solving, I aim to contribute to innovative projects and grow as a versatile developer.
          </p>
          {bios.map((bio, i) => (
            <div className="bio" key={i}>
              <span className="bioKey">
                {bio.icon}
                {bio.key}
              </span>
              <span className="bioValue">{bio.value}</span>
            </div>
          ))}

          <div className="resume__btn">
            <motion.a
              href="https://drive.google.com/file/d/1SfOhm5h5v3YawWMqkdBxY94lJqpWY4MG/view?usp=sharing"
              download="" target="blank"
              variants={buttonVariants}
              whileHover="hover"
            >
              DOENLOAD RESUME
            </motion.a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
